import { useState, useEffect, memo } from 'react';

const links = [
  { href: '#about', label: 'about' },
  { href: '#skills', label: 'skills' },
  { href: '#projects', label: 'projects' },
  { href: '#contact', label: 'contact' },
];

const PortfolioNavbar = () => {
  const [active, setActive] = useState('about');
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const sections = links.map(l => document.getElementById(l.href.slice(1))).filter(Boolean);
    if (!sections.length) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: '-40% 0px -55% 0px' }
    );
    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  const closeMobile = () => setMobileOpen(false);

  return (
    <nav className="term-nav" role="navigation" aria-label="Primary">
      <div className="term-nav-inner">
        <a href="#about" className="term-nav-brand" onClick={closeMobile}>vijoy.paul</a>
        <div className="term-nav-links">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={active === l.href.slice(1) ? 'active' : ''}
            >
              {l.label}
            </a>
          ))}
          <a
            href="https://blog.vijoypaul.com"
            target="_blank"
            rel="noopener noreferrer"
          >blog</a>
        </div>
        <button
          type="button"
          className="term-nav-mobile-toggle"
          aria-expanded={mobileOpen}
          aria-controls="term-nav-mobile-menu"
          onClick={() => setMobileOpen((o) => !o)}
        >
          {mobileOpen ? '[ x ]' : '[ menu ]'}
        </button>
      </div>
      <div
        id="term-nav-mobile-menu"
        className={`term-nav-mobile-menu${mobileOpen ? ' open' : ''}`}
      >
        {links.map((l) => (
          <a key={l.href} href={l.href} onClick={closeMobile}>{l.label}</a>
        ))}
        <a
          href="https://blog.vijoypaul.com"
          target="_blank"
          rel="noopener noreferrer"
          onClick={closeMobile}
        >blog</a>
      </div>
    </nav>
  );
};

export default memo(PortfolioNavbar);
